import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-text-2xl tw-text-danger tw-font-bold"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "This account already has access to Spellingframe.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " If you are a student of this school please contact your teacher to get your credentials. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " If you are a teacher of this school please contact your school admin to get your credentials. ", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "The current user doesn't seem to be linked to a Mathsframe account.", -1)
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " You have been logged out. Please login again with your Mathsframe credentials. ", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactLink = _resolveComponent("ContactLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.titleVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.credentialsSentVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" You will receive an email with instructions to reset your password. Remember to check your spam box. If you don't receive the email please "),
          _createVNode(_component_ContactLink),
          _createTextVNode(" for further assistance. ")
        ]))
      : (_ctx.error == 'mfUserMoved')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.isMfSchool)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" If you are the admin of this school and you don't remember you login credentials to access Spellingframe features "),
                    _createElementVNode("a", {
                      href: "",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendCredentials && _ctx.sendCredentials(...args)), ["prevent"]))
                    }, "click here"),
                    _createTextVNode(". ")
                  ]),
                  _hoisted_5,
                  _hoisted_6
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _createTextVNode(" If you don't remember your credentials to access Spellingframe features "),
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendCredentials && _ctx.sendCredentials(...args)), ["prevent"]))
                  }, "click here"),
                  _createTextVNode(". ")
                ]))
          ]))
        : (_ctx.error == 'noMfUser')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", null, [
                _createTextVNode(" Please logout and login again using your Mathsframe credentials or "),
                _createVNode(_component_ContactLink),
                _createTextVNode(" to get further assistance. ")
              ])
            ]))
          : (_ctx.error == 'logedout')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", null, [
                  _createTextVNode(" Please "),
                  (_ctx.showTryAgain)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('tryagain')), ["prevent"]))
                        }, "try again"),
                        _createTextVNode(" or")
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ContactLink),
                  _createTextVNode(" to get further assistance. ")
                ])
              ]))
  ]))
}